import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, Button} from 'reactstrap';
import {FormattedMessage, FormattedRelative} from "react-intl";
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import moment from 'moment';

class ProfileSelect extends React.Component {
    static propTypes = {
        profileList: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                advert: PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    photoUrl: PropTypes.string.isRequired,
                    title: PropTypes.string.isRequired,
                }),
                customer: PropTypes.shape({
                    id: PropTypes.number.isRequired,
                }).isRequired,
                contacts: PropTypes.arrayOf(
                    PropTypes.shape({
                        timeCreated: PropTypes.number.isRequired,
                    }).isRequired
                ).isRequired,
            }).isRequired
        ).isRequired,
        profile: PropTypes.shape({
            advert: PropTypes.shape({
                title: PropTypes.string.isRequired,
            }),
        }),
    };

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    componentWillMount() {
        this.setState({
            opened: false,
            filter: '',
        });
    }

    toggle() {
        if (this.props.profileList.length > 1) {
            this.setState({
                opened: !this.state.opened
            });
        }
    }

    onFilterChange(event) {
        const value = event.target.value;
        this.setState({
            filter: value
        });
    }

    render() {
        const {profileList, profile} = this.props;

        const filter = new RegExp(".*" + this.state.filter + '.*', 'i');
        const hasMore = profileList.length > 1;

        return (
            <div className="dropdown">
                <Button color="primary" disabled={!hasMore} className={hasMore ? "dropdown-toggle" : ''} onClick={this.toggle}>
                    {profile && profile.advert.title}
                    {!profile &&
                    <FormattedMessage id="conversation.all_conversations" defaultMessage="All conversations"/>
                    }
                </Button>
                <Modal keyboard autoFocus isOpen={hasMore && this.state.opened} modalClassName="modal-small" toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}/>
                    <ModalBody>
                        <div className="form-group">
                            <input type="text" className="form-control form-search" onChange={this.onFilterChange}/>
                        </div>

                        <div className="conv__list">
                            <Link onClick={this.toggle} to={generateUrl(routes.conversations, {advert: profileList[0].advert.id, customer: profileList[0].customer.id}, {view: 'conversation'})}
                                  className="conv__item conv__item--all">
                                <div className="conv__text">
                                    <strong>
                                        <FormattedMessage id="conversation.all_conversations" defaultMessage="All conversations"/>
                                    </strong>
                                </div>
                            </Link>

                            {profileList.filter(profile => (filter.test(profile.advert.title))).map(profile => (
                                <Link onClick={this.toggle} key={"profile-" + profile.id} to={generateUrl(routes.conversations, {
                                    customer: profile.customer.id,
                                    profile: profile.id,
                                    advert: profile.advert.id,
                                }, {view: 'conversation'})}
                                      className="conv__item conv__item--all">
                                    <div className="conv__img">
                                        <img src={profile.advert.photoUrl} alt=''/>
                                    </div>
                                    <div className="conv__text">
                                        <strong>{profile.advert.title}</strong>
                                        <div className="small">
                                            {profile.contacts.length > 0 &&
                                            <span><FormattedRelative
                                                    value={moment.unix(profile.contacts[0].timeCreated)}/> | </span>}
                                            {profile.contacts.length}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default ProfileSelect;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Title/ProfileSelect.jsx